import Avatar from '../common/Avatar';
import { API_BASE_URL } from '../../config/constants';
import { toast } from 'react-toastify';
import { formatEmail } from "../../utils/format";
import useImageUrl from '../../hooks/useImageUrl';
import React, { useState, useEffect } from "react";
import axios from 'axios';
import { ReactComponent as Checked } from '../../assets/check-green-checkin.svg'
import { getFacilityId } from '../../utils/format';
import ConfirmModal from '../common/ConfirmModal';
import { API } from '../../config/constants';


const MemberCard = ({ member, calendarScheduleId, disciplineId, handleCheckInCount }) => {
  const { firstname, lastname, email, checkedin, id, img_src, firsttimer } = member;
  const [imageUrl, setImageUrl] = useState('');
  const initials = `${firstname[0]}${lastname[0]}`;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isCheckedIn, setIsCheckedIn] = useState(checkedin == 'Yes');


  const handleOpenModal = () => setIsConfirmModalOpen(true);
  const handleCloseModal = () => setIsConfirmModalOpen(false);

  const { getUrl } = useImageUrl(imageUrl);
  useEffect(() => {

    const configImageUrl = API_BASE_URL;
    setImageUrl(configImageUrl);
  }, []);

  const handleCheckIn = async () => {
    setLoading(true);
    setError('');
    setIsConfirmModalOpen(false);

    const currentFacilityId = getFacilityId();
    const isFacilitySix = currentFacilityId == '6';

    const checkinPayload = {
      facility_id: currentFacilityId,
      calendar_schedule_id: calendarScheduleId,
      member_id: id,
      discipline_id: disciplineId,
    };

    try {

      const checkinResponse = await axios.post(API.CHECKIN_MEMBER, checkinPayload);

      if (checkinResponse.data.return !== true) {
        setError(checkinResponse.data.message || 'Check-in failed due to server error.');
        setIsConfirmModalOpen(false);
        setLoading(false);
        toast.error(checkinResponse.data.message);
        return;
      }
      if (checkinResponse.data.return === true) {
        setIsCheckedIn(true);  
        handleCheckInCount(calendarScheduleId);
      }

      setIsConfirmModalOpen(false);
      setLoading(false);
      // handleCheckInCount(calendarScheduleId);
      // toast.success(checkinResponse.data.message);

   

      // 2. BACKGROUND STEP: Initiate Payment API call (NON-BLOCKING)
      if (!isFacilitySix) {
        const payPayload = {
          member_id: id,
          facility_id: currentFacilityId,
          calendar_schedule_id: calendarScheduleId,
        };


        // This sends the request and allows the main function to proceed immediately.
        axios.post(API.PRE_POST_ORDER, payPayload)
          .then(payResponse => {
            if (payResponse.data.return === true) {
              console.log('Background Payment processed successfully.');
            } else {
              // Log warning about payment issue for diagnostics
              console.warn('Background Payment error:', payResponse.data.message || 'Payment could not be processed.');
            }
          })
          .catch(payError => {
            // Log network error for the background task
            console.error('Background Payment request failed:', payError);
          });
      }

    } catch (error) {
      // Handle network/uncaught error for the critical Check-in step
      console.error('Critical Check-in API error:', error);
      setError('Failed to connect to server during check-in. Please try again.');
    } finally {


    }
  };


  return (
    <>
      <div className="flex items-center w-full justify-between py-1 gap-2">
        <div className="flex items-center ">
          <Avatar img_src={getUrl(img_src)} initials={initials} />
          {/* Member Details */}
          <div >
            <h5 className="text-lg font-semibold w-[170px] text-left">{firstname} {lastname}</h5>
            <div className="text-xs text-left">{firsttimer == "Yes" ? 'First Timer' : ""}</div>
          </div>

          <div>
          </div>

        </div>
        {/* Avatar */}
        <div>
          <p className="text-sm text-gray-600  no-underline">{formatEmail(email)}</p>
        </div>

        <div className="w-[170px] flex justify-center items-center">


          <div className="w-[170px] flex justify-center items-center">
            {loading ? (
              // State 1: Loading (Red Bordered Circle)
              <div className="text-green-500 font-semibold w-[96px] flex justify-center">
                <Checked width="40" height="40" />
              </div>
            ) : isCheckedIn || checkedin == 'Yes'? (
              // State 2: Checked In (Display Success SVG)
              <div className="text-green-500 font-semibold w-[96px] flex justify-center">
                <Checked width="40" height="40" />
              </div>
            ) : (
              // State 3: Not Checked In (Display Check-in Button)
              <div className='w-full'>
                <button
                  onClick={handleOpenModal}
                  className="border-solid w-full border font-semibold border-[#e00000] hover:text-white py-2 px-4 rounded-md mt-2 text-[20px] hover:bg-[#e00000]"
                >
                  Check-in
                </button>
                {/* {error && <p className="text-red-500 mt-2">{error}</p>} */}
              </div>
            )}
          </div>

        </div>
      </div>

      <ConfirmModal
        isOpen={isConfirmModalOpen}
        title="Are you sure?"
        message={firstname}
        subTitle={formatEmail(email)}
        confirmText="Check-in"
        cancelText="Cancel"
        loading={loading}
        onConfirm={handleCheckIn}
        onCancel={handleCloseModal}
      />
    </>

  );
};

export default MemberCard;